import { Col, FloatingLabel, Form, Row, Alert, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faListCheck, faPenToSquare,faUser, faUserGear, faUserTie, faUsers } from "@fortawesome/free-solid-svg-icons";
import InlineRadioGroup from "../../../formik/inlineradiogroup";
import InformationCard from "../../../components/informationcard";
import Masonry from 'react-masonry-css';
import React, { useState, useEffect } from 'react'
import useMessageStore from "../../../stores/message-store";
import { useForm } from "react-hook-form";
import DockedFloatingActionButton from "../../../components/dockedfloatingactionbutton";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import useApi from "../../../hooks/use-api";
import { PrepareNullableDataForSend, ReplaceNullsWithEmptyStrings } from "../../../utilities/rhfdatanormalizationfunctions";
import { useOutletContext } from "react-router-dom";


const FaceSheet = ({}) => {
    const [clientObj, setClientObj] = useState(null);
    const [show, setShow] = useState(false);
    const addToast = useMessageStore(state => state.addToast);
    const [isLoading,setIsloading] = useState(true); //default to true

    const [states,setStates] = useState([]); //Physical States i.e. Kentucky

    const {ApplicationID} = useOutletContext();

    const {getRequest,putRequest} = useApi();

    const initialValues = {
        hasmedicare: false,
        medicarenumber: '',
        meupscheckeddate: '',
        casemanagername: '',
        casemanagerphone: '',
        casemanagerprovidernumber: '',
        casemanageraddress: '',
        casemanagercity: '',
        casemanagerstate: '',
        casemanagerzipcode: '',
        casemanagercontactfirstname: '',
        casemanagercontactlastname: '',
        casemanagercontactphone: '',
        adultdayprogramname: '',
        adultdayprogramphone: '',
        adultdayprogramaddress: '',
        adultdayprogramcity: '',
        adultdayprogramstate: '',
        adultdayprogramzip: '',
    }

    const {handleSubmit,register,control,watch,resetField,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    const getFormValues = (faceSheetData) => {
        const normalizedData = ReplaceNullsWithEmptyStrings(faceSheetData ?? {});
        const formValues = {...initialValues};

        Object.keys(initialValues).forEach((key) => {
            formValues[key] = normalizedData[key] ?? initialValues[key];
        });

        formValues.adultdayprogramstate = formValues.adultdayprogramstate === '' ? '' : `${formValues.adultdayprogramstate}`;
        formValues.casemanagerstate = formValues.casemanagerstate === '' ? '' : `${formValues.casemanagerstate}`;

        return formValues;
    }

    const _onSubmit = async(values) => {
        const sendObj = PrepareNullableDataForSend(values);
        
        const [data,status] = await putRequest('UpdateFaceSheet',{ApplicationID: ApplicationID, ...sendObj});

        if(status === 200){
            addToast(
                {
                    id: Math.random(),
                    body: "Changes submitted successfully!",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            )

            const resetObj = ReplaceNullsWithEmptyStrings(data);
            reset(getFormValues(resetObj));
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "An error occured when saving the changes.",
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                }
            )
        }
    }

    const getAll = async() => {
        setIsloading(true);

        const [definitionData,faceSheetData] = await Promise.all([
            getRequest('FaceSheetDefinitions',{timestamp: Date.now()}),
            getRequest('FaceSheet',{ApplicationID: ApplicationID,timestamp: Date.now()})
        ]);

        setIsloading(false);

        const [extractedDefinitionData,definitionStatus] = definitionData;
        const [extractedFaceSheetData,faceSheetStatus] = faceSheetData;

        if(definitionStatus === 200 && (faceSheetStatus === 200 || faceSheetStatus === 204)){
            setStates(extractedDefinitionData.states);
            
            if(faceSheetStatus === 200){
                setClientObj(extractedFaceSheetData);
                reset(getFormValues(extractedFaceSheetData));
            }
            else{
                setClientObj(null);
            }
        }
    }

    useEffect(() => {
        getAll();
    },[])


    const breakpointColumnsObj = {
        default: 3,
        576: 1,
        768: 2
      };

    const renderTransitionPlanTable = (items, typeLabel, emptyMessage) => {
        if(!items || items.length === 0){
            return <p className="mb-0">{emptyMessage}</p>;
        }

        return(
            <div className="table-responsive">
                <table className="table table-sm table-striped mb-0">
                    <thead>
                        <tr>
                            <th>{typeLabel}</th>
                            <th>Provider Name</th>
                            <th>Provider Type</th>
                            <th>Address</th>
                            <th>Phone</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            items.map((item,index) => (
                                <tr key={`${typeLabel}-${index}`}>
                                    <td>{item.servicetype}</td>
                                    <td>{item.provider}</td>
                                    <td>{item.providertype}</td>
                                    <td>{item.provideraddress}</td>
                                    <td>{item.providerphone}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    return(
        <form onSubmit={handleSubmit(_onSubmit)}>
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faUser} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Member Information</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                    <ul className="custom-list">
                        <li>
                            <h5 className="mb-0">Name</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.name : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">MAID</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.maid : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Web APP ID</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.webappid : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">DOB</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.dob : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Demographic</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.demographic : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Referral Date</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.refferaldate : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Transition Date</h5>
                            <p className="mb-0">{clientObj != null? clientObj.memberinfo.transitiondate : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">MFP Transition Coordinator</h5>
                            <p className="mb-0">{clientObj != null && clientObj.memberinfo.transitioncoordinator != null? clientObj.memberinfo.transitioncoordinator.name : "Unknown"}</p>
                            <p className="mb-0">{clientObj != null && clientObj.memberinfo.transitioncoordinator != null? clientObj.memberinfo.transitioncoordinator.phone : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">MFP Case Coordinator</h5>
                            <p className="mb-0">{clientObj != null && clientObj.memberinfo.mfpcasecoordinator != null? clientObj.memberinfo.mfpcasecoordinator.name : "Unknown"}</p>
                            <p className="mb-0">{clientObj != null && clientObj.memberinfo.mfpcasecoordinator != null? clientObj.memberinfo.mfpcasecoordinator.phone : "Unknown"}</p>
                        </li>
                        <li>
                            <fieldset className="mb-1">
                                <legend style={{fontWeight: '500',lineHeight: '1.2',marginBottom: '0',fontSize: '1.25rem'}}>Medicare</legend>
                                <label  style={{display: 'block'}}>
                                    <input type="checkbox" {...register('hasmedicare')} />
                                    Medicare?
                                </label>
                                <label htmlFor="medicarenum">Medicare #</label>
                                <input id="medicarenum" type="text" style={{width: '100%'}} {...register('medicarenumber')} />
                                <label htmlFor="meupsdate">MEUPS Checked Date</label>
                                <input id="meupsdate" type="date" {...register('meupscheckeddate')} style={{width: '100%'}} />
                            </fieldset>
                        </li>
                    </ul>
                    </InformationCard.Body>
                </InformationCard>
                <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faUserGear} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Consumer Directed Option</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                    <ul className="custom-list">
                        <li>
                            <h5 className="mb-0">Does Member Have CDO?</h5>
                            <p className="mb-0">{clientObj != null? clientObj.consumerdirectedoption.hascdo : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Start Date</h5>
                            <p className="mb-0">{clientObj != null? clientObj.consumerdirectedoption.startdate : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Rep Name</h5>
                            <p className="mb-0">{clientObj != null && clientObj.consumerdirectedoption.rep != null? clientObj.consumerdirectedoption.rep.name : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Rep Address</h5>
                            <p className="mb-0">{clientObj != null && clientObj.consumerdirectedoption.rep != null? clientObj.consumerdirectedoption.rep.address : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Rep Relation</h5>
                            <p className="mb-0">{clientObj != null && clientObj.consumerdirectedoption.rep != null? clientObj.consumerdirectedoption.rep.relation : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Rep Phone</h5>
                            <p>{clientObj != null && clientObj.consumerdirectedoption.rep != null? clientObj.consumerdirectedoption.rep.phone : "Unknown"}</p>
                        </li>
                    </ul>
                    </InformationCard.Body>
                </InformationCard>
                <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faBuilding} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Referral Form - Facility Information</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                    <ul className="custom-list">
                        <li>
                            <h5 className="mb-0">Name</h5>
                            <p className="mb-0">{clientObj != null? clientObj.facilityinfo.name : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Address</h5>
                            <p className="mb-0">{clientObj != null? clientObj.facilityinfo.address : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Contact Name</h5>
                            <p className="mb-0">{clientObj != null && clientObj.facilityinfo.contact != null? clientObj.facilityinfo.contact.name : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Contact Phone</h5>
                            <p className="mb-0">{clientObj != null && clientObj.facilityinfo.contact != null? clientObj.facilityinfo.contact.phone : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Responsible Party Contact Name</h5>
                            <p className="mb-0">{clientObj != null && clientObj.facilityinfo.responsibleparty != null? clientObj.facilityinfo.responsibleparty.name : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Responsible Party Phone</h5>
                            <p>{clientObj != null && clientObj.facilityinfo.responsibleparty != null? clientObj.facilityinfo.responsibleparty.phone : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Responsible Party Relationship</h5>
                            <p>{clientObj != null && clientObj.facilityinfo.responsibleparty != null? clientObj.facilityinfo.responsibleparty.relation : "Unknown"}</p>
                        </li>
                        <li>
                            <h5 className="mb-0">Responsible Party Address</h5>
                            <p>{clientObj != null && clientObj.facilityinfo.responsibleparty != null? clientObj.facilityinfo.responsibleparty.address : "Unknown"}</p>
                        </li>
                    </ul>
                    </InformationCard.Body>
                </InformationCard>
                <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faListCheck} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Transition Checklist - Transition Location Information</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                        <strong className="text-center">Location Information</strong>
                        <ul className="custom-list">
                            <li>
                                <h5 className="mb-0">Address</h5>
                                <p className="mb-0">{clientObj != null? clientObj.transitionchecklistinfo.address : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Phone</h5>
                                <p className="mb-0">{clientObj != null? clientObj.transitionchecklistinfo.phone : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Type</h5>
                                <p className="mb-0">{clientObj != null? clientObj.transitionchecklistinfo.type : "Unknown"}</p>
                            </li>
                        </ul>
                        <strong>Residential Provider Information</strong>
                        <ul className="custom-list">
                            <li>
                                <h5 className="mb-0">Provider Name</h5>
                                <p className="mb-0">{clientObj != null && clientObj.transitionchecklistinfo.residentialprovider != null? clientObj.transitionchecklistinfo.residentialprovider.name : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Phone</h5>
                                <p className="mb-0">{clientObj != null && clientObj.transitionchecklistinfo.residentialprovider != null? clientObj.transitionchecklistinfo.residentialprovider.phone : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Provider #</h5>
                                <p className="mb-0">{clientObj != null && clientObj.transitionchecklistinfo.residentialprovider != null? clientObj.transitionchecklistinfo.residentialprovider.providerid : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Address</h5>
                                <p className="mb-0">{clientObj != null && clientObj.transitionchecklistinfo.residentialprovider != null? clientObj.transitionchecklistinfo.residentialprovider.address : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Contact Name</h5>
                                <p className="mb-0">{clientObj != null && clientObj.transitionchecklistinfo.contact != null? clientObj.transitionchecklistinfo.contact.name : "Unknown"}</p>
                            </li>
                            <li>
                                <h5 className="mb-0">Phone</h5>
                                <p className="mb-0">{clientObj != null && clientObj.transitionchecklistinfo.contact != null? clientObj.transitionchecklistinfo.contact.phone : "Unknown"}</p>
                            </li>
                        </ul>
                    </InformationCard.Body>
                </InformationCard>
                <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faUserTie} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Independent Case Manager</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                        <fieldset>
                            <legend style={{fontWeight: 'bold',fontSize: '1rem',marginBottom: '0'}}>Case Manager Information</legend>
                        </fieldset>
                        <ul className="custom-list">
                            <li>
                                <label htmlFor="casemanagername" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Name</label>
                                <input id="casemanagername" type="text" style={{width: '100%'}} {...register('casemanagername')} placeholder="Name"/>
                            </li>
                            <li>
                                <label htmlFor="casemanagerphone" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Phone</label>
                                <input id="casemanagerphone" type="text" style={{width: '100%'}} {...register('casemanagerphone')} placeholder="(xxx) xxx-xxxx"/>
                            </li>
                            <li>
                                <label htmlFor="casemanagerprovidernumber" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Provider #</label>
                                <input id="casemanagerprovidernumber" type="text" style={{width: '100%'}} {...register('casemanagerprovidernumber')} placeholder="Provider #"/>
                            </li>
                            <li>
                                <label htmlFor="casemanageraddress" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Address</label>
                                <input id="casemanageraddress" type="text" style={{width: '100%'}} {...register('casemanageraddress')} placeholder="Address"/>
                            </li>
                            <li>
                                <label htmlFor="casemanagercity" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>City</label>
                                <input id="casemanagercity" type="text" style={{width: '100%'}} {...register('casemanagercity')} placeholder="City"/>
                            </li>
                            <li>
                                <label htmlFor="casemanagerstate" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>State</label>
                                <select id="casemanagerstate" {...register('casemanagerstate')} style={{width: '100%',height: '30px'}}>
                                    <option value=''>--State--</option>
                                    {
                                        states.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </li>
                            <li>
                                <label htmlFor="casemanagerzip" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Zip</label>
                                <input id="casemanagerzip" type="text" style={{width: '100%'}} {...register('casemanagerzipcode')} placeholder="Zip"/>
                            </li>
                        </ul>
                        <strong>Contact</strong>
                        <ul className="custom-list">
                            <li>
                                <label htmlFor="casemanagercontactfirstname" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>First Name</label>
                                <input id="casemanagercontactfirstname" type="text" style={{width: '100%'}} {...register('casemanagercontactfirstname')} placeholder="First Name"/>
                            </li>
                            <li>
                                <label htmlFor="casemanagercontactlastname" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Last Name</label>
                                <input id="casemanagercontactlastname" type="text" style={{width: '100%'}} {...register('casemanagercontactlastname')} placeholder="Last Name"/>
                            </li>
                            <li>
                                <label htmlFor="casemanagercontactphone" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Phone</label>
                                <input id="casemanagercontactphone" type="text" style={{width: '100%'}} {...register('casemanagercontactphone')} placeholder="(xxx) xxx-xxxx"/>
                            </li>
                        </ul>
                    </InformationCard.Body>
                </InformationCard>
                <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faUsers} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Adult Day Program</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                        <fieldset>
                            <legend style={{fontWeight: 'bold',fontSize: '1rem',marginBottom: '0'}}>Program Information</legend>
                        </fieldset>
                        <ul className="custom-list">
                            <li>
                                <label htmlFor="adultdayname" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Name</label>
                                <input id="adultdayname" type="text" style={{width: '100%'}} {...register('adultdayprogramname')} placeholder="Name"/>
                            </li>
                            <li>
                                <label htmlFor="adultdayphone" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Phone</label>
                                <input id="adultdayphone" type="text" style={{width: '100%'}} {...register('adultdayprogramphone')} placeholder="(xxx) xxx-xxxx"/>
                            </li>
                            <li>
                                <label htmlFor="adultdayaddress" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Address</label>
                                <input id="adultdayaddress" type="text" style={{width: '100%'}} {...register('adultdayprogramaddress')} placeholder="Address"/>
                            </li>
                            <li>
                                <label htmlFor="adultdaycity" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>City</label>
                                <input id="adultdaycity" type="text" style={{width: '100%'}} {...register('adultdayprogramcity')} placeholder="City"/>
                            </li>
                            <li>
                                <label htmlFor="adultdaystate" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>State</label>
                                <select id="adultdaystate" {...register('adultdayprogramstate')} style={{width: '100%',height: '30px'}}>
                                    <option value=''>--State--</option>
                                    {
                                        states.map((item) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </select>
                            </li>
                            <li>
                                <label htmlFor="adultdayzip" style={{fontWeight: '500', lineHeight: '1.2',fontSize: '1.25rem',marginBottom: '0'}}>Zip</label>
                                <input id="adultdayzip" type="text" style={{width: '100%'}} {...register('adultdayprogramzip')} placeholder="Zip"/>
                            </li>
                        </ul>
                    </InformationCard.Body>
                </InformationCard>
                <div></div>
                <div></div>
                <InformationCard>
                    <InformationCard.Icon>
                        <FontAwesomeIcon icon={faPenToSquare} size="xl" />
                    </InformationCard.Icon>
                    <InformationCard.Header>
                        <h6>Transition Plan</h6>
                    </InformationCard.Header>
                    <InformationCard.Body>
                        <strong>Therapies</strong>
                        {renderTransitionPlanTable(clientObj?.transitionplan?.therapies, "Therapy", "-- CLIENT HAS NO THERAPIES ENTERED --")}
                        <strong>Services</strong>
                        {renderTransitionPlanTable(clientObj?.transitionplan?.services, "Service", "-- CLIENT HAS NO SERVICES ENTERED --")}
                    </InformationCard.Body>
                </InformationCard>
          </Masonry>
          {
            isDirty
            &&
                <DockedFloatingActionButton type="submit" title="Save Changes" aria-label="Save Changes" className="btn btn-primary" disabled={isSubmitting}>
                    <FontAwesomeIcon icon={faFloppyDisk}  size="xl"/>
                </DockedFloatingActionButton>
          }
        </form>
    )
}

export default FaceSheet;
